var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M14.26 7.76a6.49 6.49 0 0 1 5.1 10.52l-.48.6-.6.48a6.5 6.5 0 1 1-4-11.6m0-2a8.5 8.5 0 1 0 5.25 15.17l5.32 5.31 1.41-1.41-5.31-5.32a8.49 8.49 0 0 0-6.69-13.75z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }